export const SCHOOL = {
  name: 'Ideal Public School',
  hindiName: 'आइडियल पब्लिक स्कूल',
  place: 'Shahapur, Khetasarai, Jaunpur',
  tagline: 'Where Education Meets Excellence and Values Shape the Future.',
  address: 'Shahapur, Khetasarai, Jaunpur, Uttar Pradesh, India',
  phones: ['+91 75118 04448', '+91 75239 76101'],
  email: 'idealpublicschool.aherar@gmail.com',
  website: 'www.idealpublicschoolaherar.com',
  whatsapp: '917511804448',
  hours: 'Mon – Sat · 8:00 AM – 3:30 PM',
  officeHours: 'Mon – Sat · 9:00 AM – 4:00 PM',
  session: '2026–27',
  mapQuery: 'Khetasarai, Jaunpur, Uttar Pradesh',
};

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Academics', path: '/academics' },
  { label: 'Admissions', path: '/admissions' },
  { label: 'Faculty', path: '/faculty' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Contact', path: '/contact' },
];

export const MORE_LINKS = [
  { label: 'School Life', path: '/school-life' },
  { label: 'Infrastructure', path: '/infrastructure' },
  { label: 'Notice & Events', path: '/notices' },
];

export const ALL_LINKS = [...NAV_LINKS, ...MORE_LINKS];

export const NOTICES = [
  { date: '12 Aug 2026', tag: 'Admission', title: 'Admissions Open for Session 2026–27 — Limited Seats', body: 'Registrations are open from Nursery to Class IX. Enquire online or visit the school office between 9 AM and 4 PM.' },
  { date: '10 Aug 2026', tag: 'Circular', title: 'Parent–Teacher Meeting on 29 August', body: 'All parents are requested to attend the PTM between 9:00 AM and 12:00 noon to discuss student progress.' },
  { date: '05 Aug 2026', tag: 'Examination', title: 'Half-Yearly Examination Date Sheet Released', body: 'Half-yearly examinations for all classes begin 21 September 2026. Date sheets are available at the school office.' },
  { date: '01 Aug 2026', tag: 'Holiday', title: 'School Closed on Raksha Bandhan', body: 'The school will remain closed on 28 August 2026 on account of Raksha Bandhan. Regular classes resume the next working day.' },
  { date: '28 Jul 2026', tag: 'Notice', title: 'New School Transport Route from Khetasarai', body: 'An additional bus route covering Khetasarai and nearby villages starts this session. Contact the office for seat availability.' },
  { date: '20 Jul 2026', tag: 'Circular', title: 'Uniform & Book Distribution Schedule', body: 'Uniforms and textbooks for the new session will be distributed class-wise from the school store. Carry the fee receipt.' },
];

export const EVENTS = [
  { date: '2026-08-15', title: 'Independence Day Celebration', time: '8:00 AM', venue: 'School Ground' },
  { date: '2026-08-29', title: 'Parent–Teacher Meeting', time: '9:00 AM', venue: 'Respective Classrooms' },
  { date: '2026-09-05', title: "Teachers' Day Programme", time: '10:00 AM', venue: 'Assembly Hall' },
  { date: '2026-09-14', title: 'Hindi Diwas — Kavi Sammelan', time: '11:00 AM', venue: 'Assembly Hall' },
  { date: '2026-09-21', title: 'Half-Yearly Examinations Begin', time: '9:00 AM', venue: 'All Classrooms' },
  { date: '2026-12-20', title: 'Annual Function & Prize Distribution', time: '5:00 PM', venue: 'School Ground' },
];

export const STATS = [
  { value: '1200+', label: 'Students Learning' },
  { value: '45+', label: 'Dedicated Teachers' },
  { value: '25+', label: 'Years of Service' },
  { value: '100%', label: 'Board Results' },
];

export const ACHIEVEMENTS = [
  { title: '100% Board Results', desc: 'Consistent first-division results in UP Board examinations year after year.' },
  { title: 'District Toppers', desc: 'Our students regularly feature among district toppers in Class X board examinations.' },
  { title: 'Sports Champions', desc: 'Block and district level winners in kabaddi, kho-kho, athletics and cricket.' },
  { title: 'Science Exhibition Winners', desc: 'Prize-winning models at the regional science exhibition for three consecutive years.' },
];

export const VALUES = [
  { title: 'Sanskar', desc: 'Character before career — discipline, respect and honesty in every classroom.' },
  { title: 'Excellence', desc: 'High expectations and steady effort, so every child performs at their best.' },
  { title: 'Curiosity', desc: 'Questions are celebrated. We teach children how to think, not what to think.' },
  { title: 'Service', desc: 'Education that gives back — to family, village and nation.' },
];

export const PRINCIPAL = {
  name: "The Principal",
  designation: 'Principal, Ideal Public School',
  qualification: 'M.A., B.Ed. — 20+ years in education',
  photo: '/images/principal.jpg',
  message: [
    'Dear Parents and Students,',
    'At Ideal Public School, we believe that education is the most powerful weapon which you can use to change the world. Every child who walks through our gates carries a dream — and it is our privilege to protect that dream, discipline it, and give it direction.',
    'We combine strong academics with strong values. Our classrooms are places of curiosity, our playgrounds are places of courage, and our teachers are guides who know every child by name. I warmly invite you to visit our campus and see the Ideal difference for yourself.',
  ],
};

export const FACULTY = [
  { name: 'Mrs. Anita Verma', role: 'Vice Principal · Science', qual: 'M.Sc. (Physics), B.Ed.' },
  { name: 'Mr. Ramesh Yadav', role: 'Mathematics', qual: 'M.Sc. (Maths), B.Ed.' },
  { name: 'Mrs. Sunita Singh', role: 'Hindi & Sanskrit', qual: 'M.A. (Hindi), B.Ed.' },
  { name: 'Mr. Arvind Kumar', role: 'English', qual: 'M.A. (English), B.Ed.' },
  { name: 'Mrs. Pooja Maurya', role: 'Social Science', qual: 'M.A. (History), B.Ed.' },
  { name: 'Mr. Sanjay Gupta', role: 'Computer Science', qual: 'MCA, PGDCA' },
  { name: 'Mrs. Rekha Patel', role: 'Primary Wing In-charge', qual: 'B.A., N.T.T., B.Ed.' },
  { name: 'Mr. Dinesh Chauhan', role: 'Physical Education', qual: 'B.P.Ed.' },
];

export const ADMIN_STAFF = [
  { name: 'Mr. Vijay Pal', role: 'Office Superintendent' },
  { name: 'Mrs. Kamla Devi', role: 'Accounts & Fee Desk' },
  { name: 'Mr. Santosh Kumar', role: 'Transport Coordinator' },
  { name: 'Mr. Ram Naresh', role: 'Lab Assistant' },
];

export const PROGRAMS = [
  { stage: 'Pre-Primary', classes: 'Nursery – UKG', focus: 'Play-based learning, phonics, motor skills, rhymes and values through activity corners.', color: 'crimson' },
  { stage: 'Primary', classes: 'Class I – V', focus: 'Strong foundations in English, Hindi, Maths and EVS with daily reading and handwriting practice.', color: 'gold' },
  { stage: 'Upper Primary', classes: 'Class VI – VIII', focus: 'Concept clarity in Science and Maths, computer literacy, projects and Olympiad preparation.', color: 'navy' },
  { stage: 'Secondary', classes: 'Class IX – X', focus: 'UP Board focused preparation, weekly tests, lab work and career guidance.', color: 'crimson' },
];

export const SUBJECT_GROUPS = [
  { group: 'Languages', items: ['Hindi', 'English', 'Sanskrit'] },
  { group: 'Sciences', items: ['Mathematics', 'Science', 'Computer Science'] },
  { group: 'Humanities', items: ['Social Science', 'Moral Education', 'General Knowledge'] },
  { group: 'Beyond Books', items: ['Art & Craft', 'Physical Education', 'Music'] },
];

export const ACADEMIC_CALENDAR = [
  { month: 'April', detail: 'Session begins · New books distribution · Parent orientation' },
  { month: 'May', detail: 'Unit Test 1 · Summer vacation begins (last week)' },
  { month: 'July', detail: 'School reopens · Inter-house competitions begin' },
  { month: 'August', detail: 'Independence Day · PTM · Unit Test 2' },
  { month: 'September', detail: "Teachers' Day · Half-yearly examinations" },
  { month: 'October', detail: 'Result declaration · Festive breaks · Sports trials' },
  { month: 'November', detail: 'Annual sports meet · Educational tours' },
  { month: 'December', detail: 'Annual function · Unit Test 3 · Winter vacation' },
  { month: 'February', detail: 'Revision tests · Board practicals' },
  { month: 'March', detail: 'Annual examinations · Session ends' },
];

export const ADMISSION_STEPS = [
  { step: '01', title: 'Enquire', desc: 'Fill the online enquiry form or call the admissions office. We will guide you on seat availability.' },
  { step: '02', title: 'Visit', desc: 'Tour the campus, meet our teachers and collect the registration form from the school office.' },
  { step: '03', title: 'Interact', desc: 'A friendly interaction / written assessment for the child, appropriate to the class applied for.' },
  { step: '04', title: 'Enrol', desc: 'Submit documents, complete fee formalities, and welcome to the Ideal family.' },
];

export const ADMISSION_DOCUMENTS = [
  'Birth certificate (photocopy)',
  'Aadhaar card of student and parents',
  'Transfer certificate (Class II onwards)',
  'Previous class report card',
  '4 passport-size photographs of the student',
  'Caste certificate (if applicable)',
];

export const IMPORTANT_DATES = [
  { label: 'Registration opens', date: 'January 2026' },
  { label: 'Interaction / assessment', date: 'February – March 2026' },
  { label: 'Session begins', date: 'April 2026' },
  { label: 'Admission helpline', date: SCHOOL.phones[0] },
];

export const FEE_NOTE = 'Ideal Public School believes quality education must remain affordable for every family of Shahapur, Khetasarai and nearby villages. Please contact the school office for the current class-wise fee structure, transport charges and sibling concessions.';

export const FACILITIES = [
  { title: 'Smart Classrooms', desc: 'Digital boards and audio-visual learning in every classroom.', span: 'wide' },
  { title: 'Computer Lab', desc: 'Modern lab with internet-enabled systems for every student.', span: 'normal' },
  { title: 'Science Lab', desc: 'Hands-on Physics, Chemistry and Biology practicals.', span: 'normal' },
  { title: 'Library', desc: 'A growing collection of books, magazines and newspapers.', span: 'tall' },
  { title: 'Playground', desc: 'Large open ground for cricket, kabaddi, kho-kho and athletics.', span: 'wide' },
  { title: 'Transport', desc: 'Safe GPS-tracked buses covering nearby villages.', span: 'normal' },
  { title: 'CCTV & Security', desc: '24×7 camera coverage and guarded entry for complete safety.', span: 'normal' },
  { title: 'Clean Water & Hygiene', desc: 'RO drinking water and separate, well-maintained washrooms.', span: 'normal' },
];

export const SCHOOL_LIFE = [
  { title: 'Sports', desc: 'Daily games period, annual sports meet, and coaching in cricket, kabaddi, kho-kho, volleyball and athletics.' },
  { title: 'Cultural Activities', desc: 'Music, dance, drama and art — every festival becomes a stage for our students.' },
  { title: 'Clubs', desc: 'Science club, literary club, eco club and sports club meet every week.' },
  { title: 'Competitions', desc: 'Debate, elocution, quiz, handwriting, drawing and Olympiads — in-house and inter-school.' },
  { title: 'Educational Tours', desc: 'Annual visits to museums, historical sites and science centres across the region.' },
  { title: 'Student Achievements', desc: 'District toppers, sports medals and exhibition prizes — our students shine everywhere.' },
];

export const TESTIMONIALS = [
  { quote: 'The teachers know my daughter by name and by heart. Her confidence in English and Maths has grown so much in one year.', author: 'Smt. Sangeeta Devi', role: 'Parent, Class IV' },
  { quote: 'Discipline, studies and values — the school gives all three. Both my sons study here and we are fully satisfied.', author: 'Sri Ram Kewal Yadav', role: 'Parent, Classes VII & IX' },
  { quote: 'I topped my block in Class X because my teachers never let me give up. Ideal Public School made me believe in myself.', author: 'Anjali Maurya', role: 'Alumna, Batch of 2025' },
  { quote: 'Clean campus, CCTV everywhere, and a bus that reaches our village on time. As a parent, safety was my biggest concern — solved.', author: 'Sri Dinesh Kumar', role: 'Parent, Class II' },
];

const U = (id, w = 1200) => `${id}&w=${w}&q=80&auto=format&fit=crop`;
export const IMG = {
  classroom: 'https://images.unsplash.com/photo-1728743264694-4ac39fa29385?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBzY2hvb2wlMjBzdHVkZW50cyUyMGNsYXNzcm9vbXxlbnwwfHx8fDE3ODY3NjI3Mzh8MA&ixlib=rb-4.1.0',
  students: 'https://images.unsplash.com/photo-1719159381916-062fa9f435a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBzY2hvb2wlMjBzdHVkZW50cyUyMGNsYXNzcm9vbXxlbnwwfHx8fDE3ODY3NjI3Mzh8MA&ixlib=rb-4.1.0',
  building: 'https://images.unsplash.com/photo-1758905458384-25ddb32be99b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxyZWQlMjBicmljayUyMHNjaG9vbCUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4Njc2MjczOHww&ixlib=rb-4.1.0',
};

export const GALLERY_ITEMS = [
  { src: '/images/hero-building.jpg', caption: 'Our Campus, Shahapur', cat: 'Campus', span: 'wide' },
  { src: U(IMG.classroom, 1000), caption: 'Learning in Progress', cat: 'Classrooms', span: 'normal' },
  { src: U(IMG.students, 1000), caption: 'Young Minds at Work', cat: 'Classrooms', span: 'normal' },
  { src: '/images/campus-gate.jpg', caption: 'Morning Assembly', cat: 'Events', span: 'tall' },
  { src: U(IMG.building, 1000), caption: 'The Red Building', cat: 'Campus', span: 'normal' },
  { src: '/images/campus-wide.jpg', caption: 'Ideal Public School — Front View', cat: 'Campus', span: 'wide' },
  { src: U(IMG.students, 900), caption: 'Group Activities', cat: 'Activities', span: 'normal' },
  { src: U(IMG.classroom, 900), caption: 'Smart Classroom Session', cat: 'Activities', span: 'normal' },
];

export const SEARCH_INDEX = [
  ...ALL_LINKS.map((l) => ({ type: 'Page', title: l.label, path: l.path, excerpt: `Visit the ${l.label} page` })),
  ...NOTICES.map((n) => ({ type: 'Notice', title: n.title, path: '/notices', excerpt: n.body })),
  ...EVENTS.map((e) => ({ type: 'Event', title: e.title, path: '/notices', excerpt: `${e.date} · ${e.venue}` })),
  ...FACILITIES.map((f) => ({ type: 'Facility', title: f.title, path: '/infrastructure', excerpt: f.desc })),
  { type: 'Page', title: 'Admission Enquiry Form', path: '/admissions', excerpt: 'Apply online for Session 2026–27' },
  { type: 'Page', title: "Principal's Message", path: '/about', excerpt: 'A word from our Principal' },
  { type: 'Page', title: 'Fee Information', path: '/admissions', excerpt: FEE_NOTE.slice(0, 90) },
  { type: 'Page', title: 'Academic Calendar', path: '/academics', excerpt: 'Month-wise planner for the session' },
];
